import { Modifier } from '../../models/order/modifier';

export default {
    modifierData: state => state.modifierData,
    // modifierList: state => state.modifierList
    modifierList: state => {
        let temp = [];
        for (let i = 0; i < state.modifierList.length; i++) {
          temp.push(new Modifier(state.modifierList[i]));
        }
        return temp;
      },
}
